import { SendEmailModal } from "components/Modal/SendEmailModal";
import { SentEmailsTable } from "components/Modal/SendEmailModal/components/SentEmailsTable/SentEmailsTable";
import { useActiveConsultationEmails } from "features/consultations/hooks/useActiveConsultationEmails";
import { usePatientData } from "features/patients/hooks/usePatientData";

import s from "./tabs.module.css";

export const EmailTab = ({ consultationId, onClose, isReadOnly = false }) => {
  const { data: patient } = usePatientData();
  const { data: activeConsultationEmails, refetch: refetchEmails } =
    useActiveConsultationEmails(consultationId);

  return (
    <>
      {!isReadOnly && (
        <SendEmailModal
          isOpen={true}
          onClose={onClose}
          patient={patient}
          inline={true}
          consultationId={consultationId}
          refetchEmails={refetchEmails}
        />
      )}
      <div className={s.sectionWrapper}>
        <div className={s.sectionHeader}>
          <h3 className={s.sectionTitle}>Emails for this Consultation</h3>
        </div>
        <div className={s.sectionContent}>
          <SentEmailsTable emails={activeConsultationEmails || []} />
        </div>
      </div>
    </>
  );
};
